var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemAlertaGeneral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "goyxg3ucna",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 0.713725 0 0 0 0 0.258824 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#goyxg3ucna)",
    transform: "translate(-55 -146) translate(42 138)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFB642",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C3.808 0 0 3.804 0 8.5S3.808 17 8.5 17 17 13.196 17 8.5 13.192 0 8.5 0zm0 14.053c-.55 0-.996-.447-.996-.996 0-.55.447-.996.996-.996.55 0 .996.447.996.996 0 .549-.447.996-.996.996zm.996-3.984c0 .549-.447.996-.996.996-.55 0-.996-.447-.996-.996v-4.98c0-.55.447-.997.996-.997.55 0 .996.447.996.996v4.98z",
    transform: "translate(13 8)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemAlertaGeneral);
export default __webpack_public_path__ + "static/media/system-alerta-general.3ed4eae7.svg";
export { ForwardRef as ReactComponent };